module.exports = __webpack_public_path__ + "static/Banner-14-f20d846f03ee3a84b5acf97508c18878.png";